import {connect} from 'react-redux';

import {DraftMessageModel} from '../../../../../libs/shared/core/src/models/api/messageModel';
import {
  ResolveDispatchProps,
  wrapActionCreator,
} from '../../../../../libs/shared/core/src/store/helpers/reduxHelpers';
import {PopoverProps} from '../../../../../libs/shared/ui/src/components/popovers/popoverTypes';
import {Dispatch} from '../../../../store/appStore';
import {createAnswerAsyncAction} from '../../../../store/data/answers/answerActions';
import {AnswerDialog} from './answerDialog';
import {AnswerDialogValues} from './answerDialogBase';

/*
 * Props.
 */

export interface AnswerDialogContainerProps extends PopoverProps {
  namespace: string;
  message: DraftMessageModel;
}

/*
 * Redux.
 */

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    createAnswerAsync: wrapActionCreator(dispatch, createAnswerAsyncAction),
  };
}

function mergeProps(
  _stateProps: unknown,
  dispatchProps: ResolveDispatchProps<typeof mapDispatchToProps>,
  ownProps: AnswerDialogContainerProps,
) {
  const onCreateClick = ({namespace, name, subject, folderId, body}: AnswerDialogValues) =>
    dispatchProps.createAnswerAsync(namespace, name, folderId, subject, body);

  return {
    ...ownProps,
    onCreateClick,
  };
}

export const AnswerDialogContainer = connect(null, mapDispatchToProps, mergeProps)(AnswerDialog);
